import { useState } from "react";
import { motion, useScroll } from "framer-motion";
import ScrollProgressRail from "../components/home/ScrollProgressRail";
import Hero from "../components/home/Hero";
import About from "../components/home/About";
import QuoteCarousel from "../components/home/QuoteCarousel";
import ProductShowcase from "../components/home/ProductShowcase";
import Brands from "../components/home/Brands";
import Services from "../components/home/Services";
import FAQSection from "../components/home/FAQSection";
import ContactSection from "../components/home/ContactSection";
import CookieConsentModal from "../components/home/CookieConsentModal";
import QuoteMethodModal from "../components/home/QuoteMethodModal";

export default function Home() {
  const { scrollYProgress: pageProgress } = useScroll();
  const [showQuoteModal, setShowQuoteModal] = useState(false);

  return (
    <div className="font-inter w-full [overflow-x:clip]">

      {/* Scroll progress indicator */}
      <motion.div
        className="fixed top-0 left-0 right-0 h-0.5 origin-left bg-gradient-to-r from-[#172b81]/50 to-[#e1ae48]/50 z-[60] pointer-events-none"
        style={{ scaleX: pageProgress }}
      />

      <ScrollProgressRail progress={pageProgress} />

      <Hero />
      <About />
      <QuoteCarousel onQuoteClick={() => setShowQuoteModal(true)} />
      <ProductShowcase />
      <Brands />
      <Services />
      <FAQSection />
      <ContactSection />

      <CookieConsentModal />
      <QuoteMethodModal open={showQuoteModal} onClose={() => setShowQuoteModal(false)} />
    </div>
  );
}
